import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import AdminHome from '@/components/admin/AdminHome'
import AdminLogin from '@/components/admin/AdminLogin'
import AdminServices from '@/components/admin/AdminServices'
import AdminAddService from '@/components/admin/AdminAddService'
import AdminServiceFields from '@/components/admin/AdminServiceFields'
import Register from '@/components/account/Register'
import Login from '@/components/account/Login'
import Listings from '@/components/account/Listings'
import CreateListing from '@/components/account/CreateListing'
import EditListing from '@/components/account/EditListing'
import Feed from '@/components/Feed'
import Favorites from '@/components/account/Favorites'
import AdminListings from '@/components/admin/AdminListings'
import AdminUsers from '@/components/admin/AdminUsers'
import AdminListingDetails from '@/components/admin/AdminListingDetails'
import ListingDetails from '@/components/account/ListingDetails'
import AdminSiteSettings from '@/components/admin/AdminSiteSettings'
import MaintenanceMode from '@/components/MaintenanceMode'
import NotFound from '@/components/NotFound'
import ForgotPassword from '@/components/account/ForgotPassword'
import ResetPassword from '@/components/account/ResetPassword'
import PayListing from '@/components/account/PayListing'
import ListingSuccess from '@/components/account/ListingSuccess'
import AdminCoupons from '@/components/admin/AdminCoupons'
import AdminCreateCoupon from '@/components/admin/AdminCreateCoupon'
import About from '@/components/About'
import ConfirmEmail from '@/components/account/ConfirmEmail'
import MyAccount from '@/components/account/MyAccount'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import FAQ from '@/components/FAQ'
import Contact from '@/components/Contact'
import * as uiv from 'uiv'
import VModal from "vue-js-modal";
import Categories from '@/components/Categories';


import AdminSiteAnnouncements from '@/components/admin/AdminAnnouncements';
import Announcements from '@/components/Announcements';
Vue.use(Router)
Vue.use(uiv)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, scrollable: true });

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: Home,
      meta : {
        title: 'Everything Cheer & Dance - Find & Be Found'
      }
    },
    {
      path: '/home',
      component: Home,
      meta : {
        title: 'Everything Cheer & Dance - Find & Be Found'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta : {
        title: 'Everything Cheer & Dance - About Us'
      }
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: Announcements,
      meta : {
        title: 'Everything Cheer & Dance - Announcements'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQ,
      meta : {
        title: 'Everything Cheer & Dance - Frequently Asked Questions'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta : {
        title: 'Everything Cheer & Dance - Contact Us'
      }
    },
    {
      path: '/privacyPolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta : {
        title: 'Everything Cheer & Dance - Privacy Policy'
      }
    },
    {
      path: '/maintenance',
      name: 'MaintenanceMode',
      component: MaintenanceMode,
      meta : {
        title: 'Everything Cheer & Dance - Maintenance Mode'
      }
    },
    {
      path: '/feed/:serviceId',

      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance'
      }
    },



    {
      path: '/feed/competitions',
      name: 'FeedCompetitions',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Competitions'
      }
    },
    {
      path: '/feed/judges',

      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Judges'
      }
    },
    {
      path: '/feed/bows',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Bows'
      }
    },
    {
      path: '/feed/music',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Music'
      }
    },
    {
      path: '/feed/djs-mc',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Event DJ/MC'
      }
    },
    {
      path: '/feed/uniforms',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Uniforms'
      }
    },
    {
      path: '/feed/choreography',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Choreography'
      }
    },
    {
      path: '/feed/floor-rental',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Floor Rental'
      }
    },
    {
      path: '/feed/photographer',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Photographer'
      }
    },
    {
      path: '/feed/venues',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Venues'
      }
    },
    {
      path: '/feed/camps',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Camps/Clinics'
      }
    },
    {
      path: '/feed/custom-camps',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Custom Camps/Clinics'
      }
    },
    {
      path: '/feed/trophies-awards',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Trophies/Awards'
      }
    },
    {
      path: '/feed/equipment',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Equipment'
      }
    },
    {
      path: '/feed/spring-floors',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Spring Floors'
      }
    },
    {
      path: '/feed/production-companies',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Productions Companies'
      }
    },
    {
      path: '/feed/training-facility',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Training Facility'
      }
    },
    {
      path: '/feed/shoes',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Shoes'
      }
    },
    {
      path: '/feed/coaches-clinics',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Coaches Clinics/Training'
      }
    },
    {
      path: '/feed/custom-clothing',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Custom Clothing'
      }
    },
    {
      path: '/feed/event-vendors',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Event Vendors'
      }
    },
    {
      path: '/feed/signs',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Signs'
      }
    },
    {
      path: '/feed/fundraising',
      component: Feed,
      meta : {
        title: 'Everything Cheer & Dance - Fundraising'
      }
    },
    {
      path: '/categories',
      component: Categories,
      meta : {
        title: 'Everything Cheer & Dance - Categories'
      }
    },






    {
      path: '/register',
      meta : {
        title: 'Everything Cheer & Dance - Register'
      },
      redirect: '/account/register'
    },
    {
      path: '/account/register',
      component: Register,
      meta : {
        title: 'Everything Cheer & Dance - Register'
      }
    },
    {
      path: '/account/register/:afterRoute',
      component: Register,
      meta : {
        title: 'Everything Cheer & Dance - Register'
      }
    },
    {
      path: '/login',
      meta : {
        title: 'Everything Cheer & Dance - Login'
      },
      redirect:'/account/login'
    },
    {
      path: '/account/login',
      name: 'Login',
      component: Login,
      meta : {
        title: 'Everything Cheer & Dance - Login'
      }
    },
    {
      path: '/account/login/:afterRoute',
      name: 'LoginAfterRoute',
      component: Login,
      meta : {
        title: 'Everything Cheer & Dance - Login'
      }
    },
    {
      path: '/account/forgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta : {
        title: 'Everything Cheer & Dance - Forgot Password'
      }
    },
    {
      path: '/account/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
      meta : {
        title: 'Everything Cheer & Dance - Reset Password'
      }
    },
    {
      path: '/account/resetPassword/:id/:key',
      name: 'ResetPasswordIdKey',
      component: ResetPassword,
      meta : {
        title: 'Everything Cheer & Dance - Reset Password'
      }
    },
    {
      path: '/account/listings',
      name: 'Listings',
      component: Listings,
      meta : {
        title: 'Everything Cheer & Dance - My Listings'
      }
    },
    {
      path: '/account/listing/details/:listingId',
      name: 'ListingDetails',
      component: ListingDetails,
      meta : {
        title: 'Everything Cheer & Dance - Listing Details'
      }
    },
    {
      path: '/account/listing/create',
      name: 'CreateListing',
      component: CreateListing,
      meta : {
        title: 'Everything Cheer & Dance - Create Listing'
      }
    },
    {
      path: '/account/listing/edit/:listingId',
      name: 'EditListing',
      component: EditListing,
      meta : {
        title: 'Everything Cheer & Dance - Edit Listing'
      }
    },
    {
      path: '/account/listing/pay/:listingId',
      name: 'PayListing',
      component: PayListing,
      meta : {
        title: 'Everything Cheer & Dance - Pay For Listing'
      }
    },
    {
      path: '/account/listing/success',
      name: 'ListingSuccess',
      component: ListingSuccess,
      meta : {
        title: 'Everything Cheer & Dance - Listing Success'
      }
    },
    {
      path: '/account/favorites',
      name: 'Favorites',
      component: Favorites,
      meta : {
        title: 'Everything Cheer & Dance - My Favorites'
      }
    },
    {
      path: '/account/email/confirm',
      name: 'ConfirmEmail',
      component: ConfirmEmail,
      meta : {
        title: 'Everything Cheer & Dance - Confirm Email'
      }
    },
    {
      path: '/account',
      name: 'MyAccount',
      component: MyAccount,
      meta : {
        title: 'Everything Cheer & Dance - My Account'
      }
    },





    {
      path: '/admin',
      name: 'Admin Home',
      component: AdminHome,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/login',
      name: 'Admin Login',
      component: AdminLogin,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/services',
      name: 'AdminServices',
      component: AdminServices,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/services/add',
      name: 'AdminAddService',
      component: AdminAddService,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/services/edit/:serviceId',
      name: 'AdminAddServiceWithServiceId',
      component: AdminAddService,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/services/fields/:serviceId',
      name: 'AdminServiceFields',
      component: AdminServiceFields,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/coupons',
      name: 'AdminCoupons',
      component: AdminCoupons,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/coupon/create',
      name: 'AdminCreateCoupon',
      component: AdminCreateCoupon,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }
    },
    {
      path: '/admin/listings',
      name: 'AdminListings',
      component: AdminListings,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }

    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsers,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }

    },
    {
      path: '/admin/listing/:listingId',
      name: 'AdminListingDetails',
      component: AdminListingDetails,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }

    },
    {
      path: '/admin/site-settings',
      name: 'AdminSiteSettings',
      component: AdminSiteSettings,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }

    },
    {
      path: '/admin/announcements',
      name: 'AdminSiteAnnouncements',
      component: AdminSiteAnnouncements,
      meta : {
        title: 'Everything Cheer & Dance - Admin'
      }

    },
    




    {
      path: '/not-found',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/not-found'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js